import ErrorNotifier from 'app/scripts/services/error-notifier';
import { TDispatch, TGetState } from 'state';
import fetchModerationUsers from '../../api/fetch-users';
import { TModerationUser } from './../types';
import { fetchUsersStart, fetchUsersSuccess, fetchUsersFailure } from './index';

const fetchUsers = (type: TModerationUser) => ({
  count = 2000, // Until pagination we must fetch as many users as possible.
  offset = 0
}: {
  count: number;
  offset: number;
}) => {
  return async (dispatch: TDispatch, getState: TGetState) => {
    dispatch(fetchUsersStart({ type }));

    try {
      const response = await fetchModerationUsers({ type, count, offset });
      const parsedResponse = parse(response);
      dispatch(fetchUsersSuccess({ ...parsedResponse, type }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to fetch user list`, { listType: type, count, offset });
      dispatch(fetchUsersFailure({ type }));
    }
  };
};

function parse(data) {
  return {
    ...data,
    ips: data.ips || [],
    users: (data.users || []).map(user => ({
      isBlacklisted: user.blacklisted,
      displayName: user.display_name,
      id: user.id,
      imageId: user.image_id,
      isOnline: user.online,
      isRegistered: user.registered,
      roles: user.roles,
      username: user.user_name,
      isWhitelisted: user.whitelisted,
      email: user.email
    }))
  };
}

export const fetchBlockedUsers = fetchUsers(TModerationUser.BlockedUsers);
export const fetchAllowedUsers = fetchUsers(TModerationUser.AllowedUsers);
export const fetchBlockedIps = fetchUsers(TModerationUser.BlockedIps);
export const fetchTeamMembers = fetchUsers(TModerationUser.TeamMembers);
